import {Base} from "@/api/Base"

export class InsuranceCompanyList extends Base {
    path = "insuranceCompany/list"
}